import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchPizzas } from './asinkActions'
import { Pizza, PizzaSliceState, Status } from './types'

const initialState: PizzaSliceState = {
    items: [],
    status: Status.LOADING,
}

export const pizzaSlice = createSlice({
    name: 'pizza',
    initialState,
    reducers: {
        setItems: (state, action: PayloadAction<Pizza[]>) => {
            state.items = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPizzas.pending, (state) => {
            state.status = Status.LOADING
            state.items = []
        })
        builder.addCase(fetchPizzas.fulfilled, (state, action) => {
            state.items = action.payload
            state.status = Status.SUCCESS
        })
        builder.addCase(fetchPizzas.rejected, (state) => {
            state.status = Status.ERROR
            state.items = []
        })
    },
})

export const { setItems } = pizzaSlice.actions

export default pizzaSlice.reducer
